/**
 * 根据身份证号获取出生日期
 *
 * @param cardNum 身份证号
 */
export function getBirthdayBycardNum(cardNum) {
    const birth = cardNum.substring(6, 10) + "-" + cardNum.substring(10, 12) + "-" + cardNum.substring(12, 14);
    return birth;
}

/**
 * 日期拆分年月日
 *
 * @param date 时间 yyyy-mm-dd 00:00:00 格式
 */
export function spiltDate(dateStr) {
    const dateArr = []
    const oneArr = dateStr.split(' ')
    const twoArr = oneArr[0].split('-')
    dateArr[0] = twoArr[0]
    dateArr[1] = twoArr[1]
    dateArr[2] = twoArr[2]
    return dateArr
}

/**
 * 获取yyyy-mm-dd日期
 *
 * @param dateStr
 * @returns {string}
 */
export function getSimpleDate(dateStr) {
    const arr = dateStr.split(" ")
    return arr[0]
}

/**
 * 获取yyyy-MM-dd日期
 * @param dateStr yyyyMMdd
 */
export function getNormalDate(dateStr) {
    const year = dateStr.substring(0,4)
    const month = dateStr.substring(4,6)
    const day = dateStr.substring(6,8)
    return year + '-' + month + '-' + day
}